<template>
    <div class="logo-map">
        <div class="logo-map-title" v-if="mapItem.hide_title == '0'">
            <i class="iconfont">&#xe6e2;</i>{{mapItem.title}}
        </div>
        <div class="logo-map-summary" v-html="mapItem.summary" v-if="mapItem.summary"></div>
        <div class="logo-map-content">
            <div class="maps" v-if="module_list && module_list.length > 1">
                <div :class="{'other': index > 1}" v-for="item,index in module_list" :key="item.module_id">
                    <div class="map-title">
                      <div class="p">{{item.module_name}}</div> 
                      <Tooltip
                            placement="top"
                            content="排名不计先后按字母排序"
                        >
                          <i class="iconfont">&#xe73a;</i> 
                        </Tooltip>
                    </div>
                    <div class="logos">
                        <Tooltip
                            placement="top"
                            v-for="e_item,e_index in item.entity"
                            :key="e_index"
                            :content="e_item.short_name"
                            v-if="isShow(index,e_index)"
                        >
                            <span class="logo-span" @click="goEntityDetail(e_item)">
                                <img :src="e_item.logo_path | logo_show" />
                            </span>
                        </Tooltip>
                    </div>
                    <span class="more" @click="list_index_open[index] = !list_index_open[index]" v-if="item.entity.length > 15 && index == 0">{{list_index_open[index]?'收起':'展开'}}<i class="iconfont" v-html="list_index_open[index]?'&#xe63b;':'&#xe648;'"></i></span>
                    <span class="more" @click="list_index_open[index] = !list_index_open[index]" v-if="item.entity.length > 20 && index == 1">{{list_index_open[index]?'收起':'展开'}}<i class="iconfont" v-html="list_index_open[index]?'&#xe63b;':'&#xe648;'"></i></span>
                    <span class="more" @click="list_index_open[index] = !list_index_open[index]" v-if="item.entity.length > 35 && index > 1">{{list_index_open[index]?'收起':'展开'}}<i class="iconfont" v-html="list_index_open[index]?'&#xe63b;':'&#xe648;'"></i></span>
                </div>
            </div>
            <div class="maps maps1" v-if="module_list && module_list.length == 1">
                <div class="other">
                    <div class="map-title">
                      <div class="p">{{module_list[0].module_name}}</div> 
                      <Tooltip
                          placement="top"
                          content="排名不计先后按字母排序"
                      >
                        <i class="iconfont">&#xe73a;</i> 
                      </Tooltip>
                    </div>
                    <div class="logos">
                        <Tooltip
                            placement="top"
                            v-for="e_item,e_index in module_list[0].entity"
                            :key="e_index"
                            :content="e_item.short_name"
                            v-if="list_index_open[0]?true:e_index < 35"
                        >
                            <span class="logo-span" @click="goEntityDetail(e_item)">
                                <img :src="e_item.logo_path | logo_show" />
                            </span>
                        </Tooltip>
                    </div>
                    <span class="more" @click="list_index_open[0] = !list_index_open[0]" v-if="module_list[0].entity.length > 35">{{list_index_open[0]?'收起':'展开'}}<i class="iconfont" v-html="list_index_open[0]?'&#xe63b;':'&#xe648;'"></i></span>
                </div>
            </div>
            <p>数据来源：<template v-if="mapItem.src">{{mapItem.src}}</template><template v-else>动脉橙产业智库</template></p>
        </div>
        <div class="spa">
            <Poptip trigger="hover" placement="bottom-end" padding="0" width="248" @on-popper-show="handleShare(paramsUid)" @on-popper-hide="handleShareHide">
                <i class="iconfont">&#xe641;</i>
                <div slot="content" class="share_cnt clear">
                    <div class="share_img"></div>
                    <p>打开微信“扫一扫”<br />点击右上角分享按钮</p>
                </div>
            </Poptip>
        </div>
    </div>
</template>
<script>
export default {
  data() {
    return {
      list_index_open: {} // 是否展开
    }
  },
  props: ['mapItem', 'paramsUid'],
  computed: {
    module_list() {
      let arr = []
      this.mapItem.content.map((a) => {
        if(a.pid == null) {
          let index = arr.findIndex((b) => a.module_id === b.module_id)
          if(index === -1){
            arr.push({
              module_name: a.module_name,
              module_id: a.module_id,
              pid: a.pid,
              sort_num: a.sort_num,
              entity: [
                {
                  entity_type: a.entity_type,
                  entity_main_page: a.entity_main_page,
                  entity_uid: a.entity_uid,
                  logo_path: a.logo_path,
                  short_name: a.short_name
                }
              ]
            })
          } else {
            arr[index].entity.push({
              entity_type: a.entity_type,
              entity_main_page: a.entity_main_page,
              entity_uid: a.entity_uid,
              logo_path: a.logo_path,
              short_name: a.short_name
            })
          }
        }
      })
      arr.sort((a,b) => a.short_name - b.short_name)
      arr.map((item,index) => { 
        this.$set(this.list_index_open, index+'', false)
        return  item
      })
      return arr
    }
  },
  methods: {
    goEntityDetail(e_item) {
      let uid = e_item.entity_uid, 
          type = e_item.entity_type
      if(type == 0){ //公司
        const { href } = this.$router.resolve({name: "CompanyDetail", params: {uid: uid}})
        window.open(href, '_blank')
      } else if(type == 1){ //机构
        const { href } = this.$router.resolve({name: "OrgDetail", params: {uid: uid}})
        window.open(href, '_blank')
      } else if (type == 2) { //人物
        const { href } = this.$router.resolve({name: "PeoDetail", params: {uid: uid}})
        window.open(href, '_blank')
      } else if(type == 3){ //医疗机构
        const { href } = this.$router.resolve({name: "HospitalDetail", params: {uid: uid}})
        window.open(href, '_blank')
      } else if(type == 6 || type == 7 || type == 8){ //研究机构 政府机构 行业协会
        if(e_item.entity_main_page) {
          const href = e_item.entity_main_page
          window.open(href, '_blank')
        }
      }
    },
    // haddleClickMore() {
    //   const { href } = this.$router.resolve({name: "AllLogoMap", query: {theme_uid: this.paramsUid, map_id: this.mapItem.map_id}})
    //   window.open(href, '_blank')
    // },
    isShow(index, e_index) {
      if(index == 0) {
        return this.list_index_open[index] ? true : e_index < 15
      } else if(index == 1) {
        return this.list_index_open[index] ? true : e_index < 20
      } else if(index > 1) {
        return this.list_index_open[index] ? true : e_index < 35
      }
    },
    handleShare(theme_uid) {
      let share_link = window.location.protocol + '//' + window.location.host + '/mindex/shareMap/'+this.mapItem.map_id+'?theme_uid=' + theme_uid
      jQuery($('.share_img')).qrcode({
        width: 80,
        height: 80,
        correctLevel: 0,
        text: share_link
      })
    },
    handleShareHide() {
      $('.share_img').html('')
    }
  }
}
</script>
<style lang="stylus" scoped>
@import '~styles/common.stylus'
.logo-map
  position: relative
  &-title
    font-size: 16px
    font-weight: 600
    commonColor(#ffffff, #333333)
    margin-bottom: 10px
    line-height: 22px
    i
      color: #FC9C7C
      margin-right: 15px
  &-summary
    commonColor(#BCBDC1, #666666)
    font-size:14px
    line-height:22px
    margin-top: -3px
    // margin-bottom: 7px
  &-content
    // border: 1px solid
    // commonBorderColor(#fa7a50, #FC9C7C)
    padding: 0 0 10px
    commonBgImg('~pic/watermark-white.png', '~pic/watermark-gray.png')
    > p
      font-size: 12px
      commonColor(#BCBDC1, #999999)
      margin-top: 10px
    .maps
      display: flex
      flex-wrap: wrap
      justify-content: center
      > div
        flex: 0 0 100%
        // text-align: center
        margin-top: 12px
        border: 1px solid
        border-image:linear-gradient(180deg, rgba(255,183,94,.6), rgba(244,107,69,.6)) 1 1;
        position: relative
        padding: 38px 8px 10px
        .map-title
          position: absolute
          font-size: 14px
          commonColor(#FC9C7C,#E26913)
          left: 0
          top: 0
          padding: 0 30px
          background:linear-gradient(90deg,rgba(252,156,124,0.25) 0%,rgba(255,217,185,0.25) 100%);
          width: 100%
          text-align: center
          line-height: 30px
          .p
            width: 100%
            overflow: hidden
            height: 30px
            line-height: 30px
            display: -webkit-box
            text-overflow: ellipsis
            word-break: break-all
            -webkit-box-orient: vertical
            -webkit-line-clamp: 1
          .ivu-tooltip
            position: absolute
            right: 12px
            top: 0
            i
              font-size: 14px
              commonColor(#BCBDC1,#aaa)
              cursor: default
          // &:before
          // &:after
          //   content: ''
          //   position: absolute
          //   height: 30px
          //   width: 11px
          //   background-size: 100% 100% !important
          //   commonBgImg('~pic/new_ele/t_left_d.png', '~pic/new_ele/t_left_l.png')
          //   top: 0
          // &:after
          //   left: -10px
          // &:before
          //   right: -10px
          //   commonBgImg('~pic/new_ele/t_right_d.png', '~pic/new_ele/t_right_l.png')
        .logos
          margin: -6px -6px 0 0
          .ivu-tooltip
            display: inline-block
            vertical-align: top
            margin: 5px 5px 0 0
            cursor: pointer
            >>> .ivu-tooltip-arrow
              border-top-color: #404040
            >>> .ivu-tooltip-inner
              background-color: #404040
            &:hover
              commonShadow(2px 4px 20px 0px rgba(0,0,0,0.2), 2px 4px 20px 0px rgba(121,133,143,0.1))
          span.logo-span
            display: inline-block
            vertical-align: top
            background-color: #fff
            width: 90px
            height: 36px
            font-size: 0
            text-align: center
            line-height: 32px
            padding: 2px
            position: relative
            &:before
              content: ''
              position: absolute
              background-color: rgba(255, 255, 255, 0.5)
              top: 0
              left: 0
              width: 90px
              height: 36px
              transition: opacity .2s
              opacity: 0
            &:hover
              &:before
                opacity: 1
            img
              max-width: 100%
              max-height: 100%
              vertical-align: middle
        .more
          color: rgba(250, 122, 80, 1)
          font-size: 12px
          display: table
          margin: 10px auto 0
          cursor: pointer
          &:hover
            color: #FC9C7C
          i
            font-size: 12px
            display: inline-block
            vertical-align: top
            margin-top: 1px
            margin-left: 6px
        &:first-of-type
          flex: 0 0 297px
          text-align: left
        &:nth-of-type(2)
          flex: 0 0 392px
          text-align: left
          margin-left: 11px
        &.other
          padding: 38px 15px 10px;
          .logos
            .ivu-tooltip
              margin: 6px 6px 0 0
        // &:nth-of-type(3)
        //   flex: 0 0 118px
        //   margin-left: 10px
      &.maps1
        > div:first-of-type
          flex: 0 0 100%
          // text-align: center
.spa
  position: absolute
  right: 0
  bottom: 8px
  width: 18px
  height: 18px
  .iconfont
    font-size: 18px
    line-height: 1
    position: absolute
    right: 0
    top: 0
    commonColor(#CCCCCC, #CCCCCC)
    &:hover
      color: #63bf61 !important
  & >>> .ivu-poptip
    position: absolute
    width: 18px
    height: 18px
    .ivu-poptip-rel
      position: absolute
      width: 18px
      height: 18px
      right: 0
      top: 0
      cursor: pointer
    .ivu-poptip-popper
      transform: translate(13px, 0)
      .ivu-poptip-inner
        border-radius: 0
        .share_cnt
          padding: 10px 20px 10px 10px
          .share_img
            width: 80px
            height: 80px
            float: left
            background: #f0f0f0
          p
            line-height: 20px
            color: #666
            float: right
            margin-top: 20px
            font-size: 14px
</style>
